import { findElementByText, normalizeText, setVisible } from "./domUtils";

export const hideBenefitsOutsideOverview = () => {
  const benefitsSection = Array.from(document.querySelectorAll("section")).find(
    (section) => {
      const title = normalizeText(section.querySelector("h2")?.textContent);
      return (
        title === "beneficios" &&
        normalizeText(section.textContent).includes(
          "cadastre beneficios por tipo de vinculo",
        )
      );
    },
  );
  if (!benefitsSection) return;

  const recruitmentButton = findElementByText("button", (text) =>
    text === "recrutamento e selecao",
  );
  const recruitmentIsActive = Boolean(
    recruitmentButton &&
      (recruitmentButton.classList.contains("bg-slate-900") ||
        recruitmentButton.getAttribute("aria-selected") === "true"),
  );
  setVisible(benefitsSection, !recruitmentIsActive);
};
